import { Card, Skeleton } from "@heroui/react";

/**
 * L'attente de la file.
 *
 * Trois cartes grises **à la forme des vraies** plutôt qu'un `Spinner` centré :
 * la hauteur est déjà celle du résultat, donc l'arrivée des signalements ne
 * fait pas sauter la page — et la maquette dit ce qui charge, ce qu'une roue
 * qui tourne ne dit pas.
 *
 * `aria-hidden` : ces blocs n'ont rien à annoncer. C'est `aria-busy` sur la
 * liste qui porte l'information « ça charge ».
 */
export function ReportsSkeleton() {
  return (
    <div aria-hidden className="flex flex-col gap-3">
      {[0, 1, 2].map((row) => (
        <Card className="flex flex-col gap-4 p-5" key={row}>
          <div className="flex items-center gap-2">
            <Skeleton className="h-6 w-20 rounded-full" />
            <Skeleton className="h-6 w-28 rounded-full" />
            <Skeleton className="ml-auto h-4 w-20" />
          </div>

          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/5" />
        </Card>
      ))}
    </div>
  );
}
